/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
    'jquery',
    'matchHeight',
    'domReady!'
], function ($) {
    $('.same-height').matchHeight();
});
